import _ from 'lodash';
import { useEffect } from 'react';
import App from '@gral/app';
import { LinearProgress } from '@mui/material';
import { useSetState } from 'react-use';
import { Autocomplete, Grid } from '@ts/storybook';
import { useAppDispatch, useAppSelector, useObjectSelector } from '@redux/store';
import { fetchData } from '@redux/slices/functionals/request/requestActions';
import { globalActions } from '@redux/slices/states/global/globalSlice';
import { EAclAction } from '@ts/ui-models';

interface IContryPickerProps {
  label?: string;
  value?: any | any[];
  onChange: (value: any) => void;
  disabled?: boolean;
  isReadOnly?: boolean;
  multiple?: boolean;
}

const CountryPicker = (props: IContryPickerProps) => {
  const dispatch = useAppDispatch();

  const [state, setState] = useSetState({
    value: props.value ? { label: props.value, value: props.value } : null,
    countryId: props.value,
    stateId: null,
    NOT_AUTHORIZED: false,
  });

  const { data, loading, error } = useObjectSelector(state => state.request['countries']);
  const listCountries = useAppSelector(state => state.global.autoSaveLists.countries);

  //#region Handler
  const onSelectCountry = value => {
    setState({ value: value, countryId: value?.value, stateId: null });
    props.onChange(value?.value);
  };
  //#endregion

  useEffect(() => {
    if (!App.cxStore.checkPermission('taCountry', EAclAction.READ)) {
      setState({ ...state, NOT_AUTHORIZED: true });
    }
    if (!listCountries) {
      dispatch(
        fetchData({
          key: 'countries',
          url: '/api/countries',
          dataBody: {},
          options: {
            dataAfterAction: { key: 'countries' },
            afterAction: globalActions.autoSaveList,
          },
        })
      );
    }
  }, []);

  useEffect(() => {
    if (typeof props.value === 'string' && props.value !== state.value?.value) {
      setState({ ...state, value: { label: props.value, value: props.value } });
    }
  }, [props.value]);

  if (loading || !listCountries) return <LinearProgress variant="indeterminate" />;

  if (props.isReadOnly && !state.value) return;

  return (
    <Grid size={{ xs: 12 }}>
      <Autocomplete
        label={props.label || 'Country'}
        multiple={props.multiple}
        value={state.value}
        onChangeValue={onSelectCountry}
        options={listCountries?.map(country => ({
          label: country.name,
          value: country.logicalId,
        }))}
        stProps={{
          textInput: {
            disabled: props.disabled,
            isReadOnly: props.isReadOnly,
          },
        }}
      />
    </Grid>
  );
};

export default CountryPicker;
